export default {
    state: _ => {
        return {
            window_width: window.innerWidth,
            window_height: window.innerWidth,
        }
    },
    getters: {
        window_width(state) {
            return state.window_width;
        },

        isSmallScreen: (state) => (site, component) => {

            if (site === "dashboard" && component === "resultRowBody")
                return state.window_width < 1220

            else if (site === "screener")
                return state.window_width < 1050

            else if (site === "keyratios" && component === "mainDiv")
                return state.window_width < 765

            return state.window_width < 1000
        },

        isMobilePortrait: (state) => (site, component) => {
            if (site === "screener")
                return state.window_width < 650

            return state.window_width < 500
        },

        isNavToShorten: (state) => () => {
            return state.window_width < 1280
        },

        isAtLeastTablet: (state) => () => {
            return state.window_width >= 834
        },

        isAtLeastDesktop: (state) => () => {
            return state.window_width >= 1280
        },

        isPortrait: (state) => () => {
            return state.window_height > state.window_width
        },

    },
    mutations: {
        changeWindowWidth(state, value) {
            state.window_width = value;
        }
    },
    actions: {
        listenOnPageResize(state) {
            window.addEventListener('resize', () => {
                state.commit("changeWindowWidth", window.innerWidth)
            })
        }
    }
};